import React, { useContext } from 'react'
import StdForm from '../stdForm/StdForm';
import Students from '../students/Students';
import StudentsSepa from '../studentsSepa/StudentsSepa';
import TodoContext from '../todoCtx/TdoCtx';
import "./doubleTodoList.css"

const DoubleTodoList = ({dragItem}) => {

    const {dblListItems, setDblListItems, showDblList, setShowDblList, dblListItemsSepa, setDblListItemsSepa, compTodosMove1, showRecycleBin,setShowRecycleBin, showForm, setShowForm, students, showStudents,showClass8, setShowClass8, storedId, setStoredId, setShowStudents,setShowDblListSepa,showStudentsSepa, setShowStudentsSepa, studentsSepa, setStudentsSepa, studentName, setStudentName, studentsSepaForm, setStudentsSepaForm, studentClass, setStudentClass, setFormData,showEditForm, setShowEditForm, formData} = useContext(TodoContext);


    const handleShowAll = () => {

      console.log("show all")

      setShowStudents(showStudents => !showStudents);

      setShowStudentsSepa(false);
     
  };



    const   handleStdForm = (event,id) => {

      

        

      const itemFound=students.find((student)=>{
        return student.id === id
      });
        console.log("item found:",itemFound);


          if ( !itemFound) {

            console.log("if block")

            const sepaStudent = dblListItemsSepa.find(dblListItemSepa => { 
              return dblListItemSepa.id === id}); 

              console.log("sepaStudent", sepaStudent);

              const name = sepaStudent.fullName;

              const classStd = sepaStudent.class;

              console.log("name", name);
              console.log("classStd", classStd);

              setStudentName(name);
              setStudentClass(classStd);

              setShowClass8(showClass8 => !showClass8);

            // setStudentsSepaForm(sepaStudent);

            console.log("studentsSepaForm",studentsSepaForm);

            setShowForm(true);

            setStoredId(id);

            setShowStudentsSepa(false);

            

          }

          else{

            

                        
            const newStudentSingleDb = { fullName : formData.fullName, email : formData.email, number : formData.number,  class : studentClass, id: storedId  };

            console.log("newStudentSingleDb",newStudentSingleDb);

            setStudentName(newStudentSingleDb.fullName);
            

            setShowForm(false);
            setShowEditForm(false);


            const singleStudent = students.filter(student => { 
              return student.id === id}); 
              
            setStudentsSepa(singleStudent);

            console.log("studentsSepa", studentsSepa);

            

            setShowStudentsSepa(true);

            setShowStudents(false);

            // setShowStudents(true);

            // setShowClass8(false);

            // setShowDblList(false);

          }

          

                  // setShowDblList(false);
  

    };

    const handleBack = event => {
      // 👇️ toggle shown state   
      setShowDblList(false);

      setShowStudents(false);

      setShowStudentsSepa(false);

      setFormData("");

      setDblListItemsSepa([]);

      setShowForm(false);

      // 👇️ or simply set it to true
      // setIsShown(true);
    };


  return (

   <>

<div className='btnContainer'>

<button className='btnShowAll' type='button'onClick={handleShowAll} >SHOW ALL</button>




<button className='btnCancel' type='button'onClick={handleBack} >BACK TO START</button>

</div>

   {showForm && <StdForm dragItem={dragItem} />}

   {showStudents && <Students/>}

   { (showStudentsSepa) && <StudentsSepa/>}

   {(!showForm || !showStudents || !showDblList || !showStudentsSepa || !showEditForm) && <div className='copyInsideDiv'>

    {dblListItemsSepa.length === 0 ? <div className='noStd'> No Students. Add some</div> :



<ul > <div id="replace" className="copyInside"  >   
{
  dblListItemsSepa && dblListItemsSepa.map((dblListItemSepa,index)=>(
    <li key={dblListItemSepa.id} > <div onClick={event => handleStdForm(event, dblListItemSepa.id)} className='dblTodoListItem' 
      >  {dblListItemSepa.fullName}

  

  </div>

  
          
    </li>

    
    
  
    
  ))
  }



  {/* {
  dblListItemsSepa && compTodosMove1.map((copyTodo,index)=>(
    <li key={index} > <div className='dblTodoListItem' 
      > {copyTodo.fullName}

  

  </div>

  
          
    </li>

    
    
  
    
  ))
} */}

  

</div>    
</ul>
}

</div>
}






    </>

  )
}
export default DoubleTodoList